// Copyright 2005-2006 Jim Radford <radford@blackbean.org>
// Copyright 2005-2006 David Caldwell <david@porkrind.org>

var dom = require('./dom'), px=dom.px, doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, URL=dom.URL, on_load=dom.on_load, animate_next_frame=dom.animate_next_frame;
var score = require('./score'), Stat=score.Stat;
var lib = require('./lib'), inherit=lib.inherit, shuffle_perfect=lib.shuffle_perfect;
var plat = require('./platform');
var score_game = require('./score_game');
var KeyboardFocusAutoPause = require('./keyfocus');
var DrawThreeDSquare = require('./3dsquare');

function img(source, r, c, width, height) {
    var image=document.createElement("img");
    image.src=source;
    image.style.width=px(width);
    image.style.height=px(height);
    image.width=width;
    image.height=height;
    image.style.position="absolute";
    image.style.left=px(c);
    image.style.top=px(r);
    image.style.border="0";
    return image;
}

function img_move(img, r, c) {
    img.style.left = px(c);
    img.style.top  = px(r);
}

function chamfer_row(grid, r, edges) {
     if (r >= 0 && r < grid.length)
         for (var c=0; c<grid[r].length; c++)
             grid[r][c] && grid[r][c].chamfer(grid, r, c, edges);
     return true;
}
function chamfer(grid) {
     for (var r=0; r<grid.length; r++)
        chamfer_row(grid, r);
}

var north = 1<<0, east = 1<<1, south = 1<<2, west = 1<<3;

class square {
    constructor(color, r, c, edge, ghost) {
        this.color = color;
        this.r = r;
        this.c = c;
        this.edge = edge;
    }
    // Implement these in the subclass
    copy() {}
    move(r, c) {}
    show(div) {}
    hide() {}
    draw() {}

    same(grid, r, c) {
            return r >= 0 && r < grid.length && grid[r] &&
                c >= 0 && c < grid[r].length && grid[r][c] &&
                this.color == grid[r][c].color;
    }

    toString() {
            return "" + this.color + ":" + this.edge + "(" + this.c + "," + this.r + ")";
    }

    chamfer(grid, r, c, edges) {
            var edge =
                (this.same(grid,r-1,c) ? north : 0) |
                (this.same(grid,r+1,c) ? south : 0) |
                (this.same(grid,r,c-1) ? west :  0) |
                (this.same(grid,r,c+1) ? east :  0);
            if (edges == undefined) edges = 0xf;
            if ((edge & edges) != (this.edge & edges)) {
                this.edge = (this.edge & ~edges) | (edge & edges);
                this.draw();
            }
    }
}

class img_square extends square {
    color_map = ["red", "purple", "aqua", "yellow", "orange", "blue", "green", "grey", "maroon" ];

    edge_map = (
            function () {
                var map = [];
                for (var i=0; i<16; i++)
                    map[i] = (i&north?"n":"")+(i&south?"s":"")+(i&east?"e":"")+(i&west?"w":"");
                return map;
            }
    )();

    source() {
            return "blocks/"+this.color_map[this.color]+"-"+blocksize+"-"+this.edge_map[this.edge] + ".png";
    }

    copy() {
            return new img_square(this.color, this.r, this.c, this.edge);
    }

    move(r, c) {
            this.r = r;
            this.c = c;
            if (this.img)
                img_move(this.img, r*blocksize, c*blocksize);
    }

    show(div) {
            if (this.img == undefined)
                this.img = img(this.source(), this.r*blocksize, this.c*blocksize, blocksize, blocksize);
            div.appendChild(this.img);
    }

    hide() { this.img.parentNode.removeChild(this.img) }
    draw() { if (this.img) this.img.src = this.source(); }
}

class canvas_square extends square {
    constructor(color, r, c, edge, ghost) {
        super(color, r, c, edge);
        this.set_origin(0,0);
        this.ghost = ghost;
    }

    colors = [{ name: "red",        r:0xd0, g:0x00, b:0x00 },
              { name: "purple",     r:0xd0, g:0x00, b:0xd0 },
              { name: "aqua",       r:0x10, g:0x50, b:0xd0 },
              { name: "yellow",     r:0xd0, g:0xd0, b:0x00 },
              { name: "orange",     r:0xd0, g:0x70, b:0x00 },
              { name: "blue",       r:0x00, g:0x00, b:0xd0 },
              { name: "green",      r:0x00, g:0xd0, b:0x00 },
              { name: "grey",       r:0x66, g:0x66, b:0x66 },
              { name: "maroon",     r:0xa0, g:0x20, b:0x10 }];

    outline_color_func(kind, main) {
            if (kind == "Main") return { r:0, g:0, b:0, a:0 }
            return main;
    }

    draw() {
            if (!this.context) return;
            this.erase(); // When re-chamfering lines we need to erase. In other cases someone already called hide() and this is redundant.
            DrawThreeDSquare(this.context, (this.oc + this.c)*blocksize,(this.or + this.r)*blocksize,blocksize, this.ghost ? Math.floor(blocksize/8) : Math.floor(blocksize/5),2,this.colors[this.color],
                             this.edge & north,this.edge & south,this.edge & east,this.edge & west, this.ghost ? this.outline_color_func : undefined)
    }

    erase() {
            if (this.context)
                this.context.clearRect((this.oc + this.c) * blocksize, (this.or + this.r) * blocksize, blocksize, blocksize);
    }

    set_origin(or, oc) {
            this.or = or;
            this.oc = oc;
    }

    copy() {
            return new canvas_square(this.color, this.r, this.c, this.edge, this.ghost);
    }

    move(r, c) {
            if (this.visible) this.erase();
            this.r = r;
            this.c = c;
            if (this.visible) this.draw();
    }

    show(canvas) {
            this.visible = true;
            this.canvas = canvas;
            this.context = canvas.getContext('2d');
            this.draw();
    }

    hide(erase) {
            this.visible = false;
            if (erase !== false) this.erase();
    }
}

class piece {
    constructor(color, coords, square, ghost) {
        this.color = color;
        this.squares = [];
        for (var i in coords)
            this.squares.push(new square(color, coords[i][0], coords[i][1], 0, ghost));

        var grid = [[],[],[],[]]; // temporary grid for chamfering
        for (var s in this.squares)
            grid[this.squares[s].r][this.squares[s].c] = this.squares[s];
        chamfer(grid);
    }
    move(r, c) {}
    show(div) {}
    hide() {}
}

class img_piece extends piece {
    constructor(color, coords, ghost) {
        super(color, coords, img_square, ghost);

        this.div = doc.el("div", {style: {position:"absolute", opacity: ghost == true ? .4 : 1, zIndex: ghost == true ? 1 : 2}});
        for (var i in this.squares)
            this.squares[i].show(this.div);
    }
    move(r, c) {
            this.div.style.top = px(r*blocksize);
            this.div.style.left = px(c*blocksize);
            return this;
    }
    show(div) { div.appendChild(this.div); return this.div; }
    hide() { if (this.div.parentNode) this.div.parentNode.removeChild(this.div);  return this.div; }
}

class canvas_piece extends piece {
    constructor(color, coords, ghost) {
        super(color, coords, canvas_square, ghost);
    }
    draw() {
            for (var s of this.squares)
                s.draw(this.r, this.c);
    }
    erase() {
            for (var s of this.squares)
                s.erase();
    }
    move(r, c) {
            if (this.visible) this.erase();
            for (var s of this.squares)
                s.set_origin(r,c);
            if (this.visible) this.draw();
            return this;
    }
    show(canvas) {
            if (this.visible) return;
            this.visible = true;
            for (var s of this.squares)
                s.show(canvas);
    }
    hide(erase) {
            if (!this.visible) return;
            this.visible = false;
            for (var s of this.squares)
                s.hide(erase);
    }
}

var blocksize=20;
class Sirtet extends KeyboardFocusAutoPause.mixin(score_game) {
  constructor(board_div, next_div, score_div, level_div, lines_div, highscore_div, highscoretabs_div, start_div, pause_div, next_toggle_div, slow_drop_div) {
    super();
    this.init("sirtet", score_div, highscore_div, highscoretabs_div);
    this.div = {};
    this.div.board = board_div;
    this.div.next = next_div;
    this.div.start_button = start_div;
    this.div.pause_button = pause_div;
    this.div.next_checkbox = next_toggle_div;
    this.div.slow_drop_checkbox = slow_drop_div;
    this.div.start_button.onclick = function() { this.new_game(); }.bind(this);

    this.init_keyboard_focus_auto_pause(this.div.board, this.div.pause_button);

    this.div.next_checkbox.onclick = function() { this.next_toggle(this.div.next_checkbox.checked); }.bind(this);

    this.level = new Stat(level_div, "level", this.stats);
    this.lines = new Stat(lines_div, "lines", this.stats);

    this.blocks = new Array(22);

    this.next_toggle(1);

    this.sets_in_bag = 1;

    this.gameover = undefined;

    this.bottom_tolerance = 1; // extra moves on the ground
    this.animating = {};

    this.register_key_events(function(event) {
        //print("x: "+ event.target.x + ", y: "+ event.target.y + "\n");
        switch(event.key) {
            case "+":      this.resize(++blocksize); return false;
            case "-":      this.resize(--blocksize); return false;
            case "p":
            case "escape": this.key_pause();   return false;
            case "n":      this.next_toggle(); return false;
        }
        if (this.paused || this.gameover || this.animating.line_removal) return true; // No input allowed in these states!
        switch(event.key) {
            case "k":
            case "up":     this.rotate();      return false;
            case "space":  this.drop();        return false;
            case "down":   if (this.slow_drop()) this.down(); else this.drop(); return false;
            case "j":
            case "left":   this.left();        return false;
            case "l":
            case "right":  this.right();       return false;
            case "i":      if (this.level.get() < 9) { this.level.inc(1); this.stats.inc("levels_incremented") };
        }
    }, "keydown");

    this.resize = function(size) {
        if (board_div.tagName.toLowerCase() == 'canvas') {
            blocksize = size;
            this.div.board.height = 22*size;
            this.div.board.width = 10*size;
            this.div.next.height = 2*size;
            this.div.next.width = 4*size;
            this.div.board.getContext('2d').clearRect(0, 0, this.div.board.width, this.div.board.height);
            this.div.next.getContext('2d').clearRect(0, 0, this.div.next.width, this.div.next.height);

        } else {
            blocksize = size = size > 32 ? 32 : size < 10 ? 10 : size;
            this.div.board.style.height = px(22*size);
            this.div.board.style.width = px(10*size);
            this.div.next.parentNode.style.height =
            this.div.next.style.height = px(2*size);
            this.div.next.style.width = px(4*size);
        }
        if (this.gameover) {
            this.gameover.style.width  = px(10*size);
            this.gameover.style.height = px( 5*size);
            this.gameover.style.top    = px( 9*size);
        }
        if (this.paused) {
            this.paused_div.style.width  = px(10*size);
            this.paused_div.style.height = px( 5*size);
            this.paused_div.style.top    = px( 9*size);
        }
        this.pieces_reset();
        this.pieces_generate();
        this.update();
        if (this.piece != undefined) {
            this.pieces[this.piece][this.orient].hide();
            this.pieces[this.piece][this.orient].move(this.r, this.c);
            this.pieces[this.piece][this.orient].show(this.div.board);
        }
        if (this.next != undefined) {
            this.pieces_next[this.next].hide();
            this.pieces_next[this.next].show(this.div.next);
        }
    };

    if (board_div.tagName.toLowerCase() == 'canvas') {
        this.piece_factory = canvas_piece;
        this.square_factory = canvas_square;
    } else {
        this.piece_factory = img_piece;
        this.square_factory = img_square;
    }

  }

  pieces_generate() {
    var d = [
        { sym:2, rc:[[1, 0], [1, 1], [1, 2], [1, 3]], o:[1, 2] }, // J
        { sym:4, rc:[[1, 0], [1, 1], [1, 2], [0, 2]], o:[1, 1] }, // I
        { sym:2, rc:[[1, 1], [1, 2], [0, 2], [0, 3]], o:[1, 2] }, // S
        { sym:4, rc:[[0, 1], [1, 1], [1, 2], [1, 3]], o:[1, 2] }, // L
        { sym:2, rc:[[0, 0], [0, 1], [1, 1], [1, 2]], o:[1, 1] }, // Z
        { sym:1, rc:[[0, 1], [0, 2], [1, 1], [1, 2]], o:[1, 1] }, // O
        { sym:4, rc:[[1, 0], [1, 1], [0, 1], [1, 2]], o:[1, 1] }  // T
    ];
    this.pieces = [];
    this.ghosts = [];
    this.pieces_next = [];
    for (var color=0; color<d.length; color++) {
        this.pieces[color] = [];
        this.ghosts[color] = [];
        this.pieces_next[color] = new this.piece_factory(color, d[color].rc);
        for (var o=0; o<d[color].sym; o++) {
            this.pieces[color].push(new this.piece_factory(color, d[color].rc));
            this.ghosts[color].push(new this.piece_factory(color, d[color].rc, true));
            for (var s in d[color].rc) { // rotate 90
                var  r = d[color].rc[s][0], c = d[color].rc[s][1];
                var or = d[color].o[0],    oc = d[color].o[1];
                d[color].rc[s] = [or-(c-oc), oc+(r-or)];
            }
        }
    }
    this.first = [0, 1, 3, 6]; // J, I, L, T
  }
  pieces_reset() {
    if (this.pieces)
        for (var color=0; color<this.pieces.length; color++) {
            this.pieces_next[color].hide();
            for (var o=0; o<this.pieces[color].length; o++)
                this.pieces[color][o].hide();
            for (var o=0; o<this.ghosts[color].length; o++)
                this.ghosts[color][o].hide();
        }
  }

  remove_all() {
    for (var r=0; r<this.blocks.length; r++)
        if (this.blocks[r])
            for (var c=0; c<this.blocks[r].length; c++)
                this.remove(r,c);
  }

  empty(r, c) {
    return r >= 0 && r < this.blocks.length &&
           c >= 0 && c < this.blocks[r].length &&
           this.blocks[r][c] == undefined;
  }

  fits(piece, r, c) {
    for (var s=0; s<piece.squares.length; s++) {
        var sq = piece.squares[s];
        if (!this.empty(r + sq.r, c + sq.c))
            return;
    }
    return piece;
  }

  down  () { return this.move(1,0,0) }
  left  () { return this.move(0,-1,0) }
  right () { return this.move(0,1,0) }
  rotate() { return this.move(0,0,1) }

  move(dr, dc, i) {
    var o = (this.orient+i) % this.pieces[this.piece].length
    var piece = this.pieces[this.piece][o];
    if (!this.fits(piece, this.r + dr, this.c + dc)) {
        if      (i && this.fits(piece, this.r + dr, this.c + dc + 1)) dc++;
        else if (i && this.fits(piece, this.r + dr, this.c + dc - 1)) dc--;
        else return;
    }
    this.move_ghost(dr, dc, o);
    piece.move(this.r += dr, this.c += dc);
    if (this.orient != o) {
        this.pieces[this.piece][this.orient].hide();
        this.pieces[this.piece][o].show(this.div.board);
        this.orient = o;
    }
    if (this.bottom)
        this.stats.inc(i ? "bottom_rotates" : "bottom_slides");
    return true;
  }

  move_ghost(dr, dc, o) {
    var ghost = this.ghosts[this.piece][o];
    for (var r = this.r + dr; this.fits(ghost, r+1, this.c + dc); r++)
        ;
    ghost.move(r, this.c+dc);
    if (this.orient != o) {
        this.ghosts[this.piece][this.orient].hide();
        this.ghosts[this.piece][o].show(this.div.board);
    }
  }

  drop() {
    cancel_timeout(this.timeout);
    var piece = this.pieces[this.piece][this.orient];
    for (var i=0; this.fits(piece, this.r+i+1, this.c); i++)
        ;
    this.score.inc(i*(this.level.get()+1));
    this.move(i,0,0);
    this.bottom=this.bottom_tolerance;
    this.step(true);
    this.stats.inc("drops");
    this.stats.inc("drop_height_total", i);
  }

  update() {
    for (var r=0; r<this.blocks.length; r++)
       if (this.blocks[r])
           for (var c=0; c<this.blocks[r].length; c++)
                if (this.blocks[r][c]) {
                    this.blocks[r][c].hide();
                    this.blocks[r][c].img = undefined;
                    this.blocks[r][c].show(this.div.board);
                }
  }
  move_to(square, r, c) {
    this.blocks[r][c] = square;
    square && square.move(r,c);
    square && square.show(this.div.board);
  }
  remove(r) {
    for (var c=0; c<this.blocks[r].length; c++)
        this.blocks[r][c] && this.blocks[r][c].hide();
    var removed = this.blocks[r]; this.blocks[r] = Array(10);
    return removed;
  }
  insert(r, row) {
    for (var c=0; c<row.length; c++)
        this.move_to(row[c], r, c);
  }
  merge(complete) {
    this.ghosts[this.piece][this.orient].hide(false);
    var n, piece = this.pieces[this.piece][this.orient];
    for (var s=0; s<piece.squares.length; s++) {
        var sq = piece.squares[s].copy();
        this.move_to(sq, this.r+sq.r, this.c+sq.c);
    }
    // Count empty holes the player left. Note that it doesn't take into account the lines that are
    // subsequently removed which may open the "holes" up to the sky (and therefore not really count as
    // holes). Perhaps a better way would be to compare the state of the board before merge/line removal and
    // after, counting holes in each and noting the increase (decreases wouldn't matter).
    for (var s=0; s<piece.squares.length; s++)
        for (var r=this.r+piece.squares[s].r+1; r<this.blocks.length && !this.blocks[r][this.c+piece.squares[s].c]; r++)
            this.stats.inc("holes_created");
    piece.hide(false);

    var full_rows = [];
    for (let r=this.blocks.length-1; r>=0; r--) {
        for (var c=0; c<this.blocks[r].length; c++)
            if (this.empty(r,c))
                break;
        if (c == this.blocks[r].length) {
            full_rows[r] = true;
            this.remove(r);
        }
    }

    if (full_rows.length == 0)
        return complete();

    for (var r in full_rows) {
        if (!full_rows[r-0-1]) chamfer_row(this.blocks, r-0-1, south);
        if (!full_rows[r-0+1]) chamfer_row(this.blocks, r-0+1, north);
    }

    const total_time = 250, blinks = 3;
    this.animate(function*() {
                     this.animating.line_removal = true;
                     for (var count=0; count<blinks*2; count++) {
                         for (var r in full_rows) {
                             this.remove(r);
                             for (var c=0; c<this.blocks[r].length; c++)
                                 this.move_to(new this.square_factory(7, 0, 0, 0, !(count & 2)), r, c);
                         }
                         yield total_time / (blinks*2);
                     }
                     delete this.animating.line_removal;

                     var full = 0;
                     for (var r=this.blocks.length-1; r>=0; r--) {
                         if (full_rows[r]) {
                             full++; this.remove(r);
                         } else {
                             full && this.insert(r+full, this.remove(r));
                         }
                     }
                     this.score.inc( (1<<full) * (this.level.get() + (this.show_next || this.seen_next ? 1 : 5)) );
                     this.seen_next = false;
                     this.faster(this.lines.inc(full));
                     complete();
                     this.step(false);
                 }.bind(this));
  }

  animate(animate_generator) {
    var start = Date.now();
    var animate = animate_generator();
    var frame = (dt, t) => {
        var state = animate.next();
        if (!state.done)
            timeout(state.value, frame);
    };
    frame();
  }

  faster(lines) {
    var level = this.level.get();
    if (level <  6 && lines > (level+1)*10) level = this.level.inc(1);
    if (level == 6 && lines >  74) this.level.set(7);
    if (level == 7 && lines >  89) this.level.set(8);
    if (level == 8 && lines > 104) this.level.set(9);
  }

  pick_next() {
    this.piece = this.next;
    if (this.piece == undefined) // Don't be annoying on the first piece (it doesn't really add challenge, it just makes the 2nd piece suck).
        this.piece = this.first[Math.floor(Math.random()*this.first.length)];
    this.orient = 0;
    this.r = 0;
    this.c = 3;

    if (this.next != undefined)
        this.pieces_next[this.next].hide();
    if ((this.bag_pos = (this.bag_pos + 1) % this.bag.length) == 0)
        shuffle_perfect(this.bag);
    this.next = this.bag[this.bag_pos];
    this.pieces_next[this.next].show(this.div.next);

    var piece = this.pieces[this.piece][this.orient];
    if (this.fits(piece, this.r, this.c)) {
        this.move_ghost(0,0,this.orient);
        this.ghosts[this.piece][this.orient].show(this.div.board);
        piece.move(this.r, this.c);
        piece.show(this.div.board);
        this.stats.inc("pieces");
    } else {
        this.piece = this.orient = undefined;
        cancel_timeout(this.timeout);
        this.gameover = img("hopeless/gameover.png", blocksize*9,0,10*blocksize, 5*blocksize);
        this.gameover.style.zIndex=2;
        this.div.board.appendChild(this.gameover);
        this.div.pause_button.disabled=true;
        this.end_game();
    }
  }

  delay = [70,67,55,40,34,25,20,18,14,9,5];
  step(move) {
    if (move && !this.down() && this.bottom++ == this.bottom_tolerance) {
        this.bottom=0;
        this.merge(() => this.pick_next());
    }
    if (!this.gameover && !this.animating.line_removal)
        this.timeout = timeout((this.delay[this.level.get()]+(this.r<3?10:0))*10, function() { this.step(true); }.bind(this));
  }

  pausable() {
    return !this.gameover;
  }
  on_pause() {
    cancel_timeout(this.timeout);
    this.paused_div = img("hopeless/paused.png", blocksize*9,0,10*blocksize, 5*blocksize);
    this.paused_div.style.zIndex=2;
    this.div.board.appendChild(this.paused_div);
  }
  on_unpause() {
    this.paused_div.parentNode.removeChild(this.paused_div);
    this.paused_div = undefined;
    this.step();
  }

  slow_drop() {
    return this.div.slow_drop_checkbox.checked;
  }

  next_toggle(value) {
    this.show_next = value == undefined ? !this.show_next : value;
    this.seen_next |= this.show_next;
    this.div.next.style.display = this.show_next ? "block" : "none";
    if (this.div.next_checkbox.checked != value) this.div.next_checkbox.checked = value;
  }

//var stats_ = new stats(this.name = name);
  new_game(seed) {
    score_game.prototype.new_game.call(this,seed);

    //for (var c=0; c<this.pieces.length; c++)
    //    for (var o=0; o<this.pieces[c].length; o++) {
    //        this.pieces[c][o].move(c*4,0*4);
    //        this.pieces[c][o].show(this.div.board);
    //    }
    //return;

    this.next = undefined;
    this.bag = [];
    for (var c=0; c<this.pieces.length * this.sets_in_bag; c++)
        this.bag[c] = c % this.pieces.length;
    this.bag_pos = -1;

    if (this.paused) this.pause(false); // Will start timout for previous game!

    if (this.timeout) cancel_timeout(this.timeout);
    this.remove_all();
    this.pieces_reset();

    if (this.gameover != undefined) {
        this.gameover.parentNode.removeChild(this.gameover);
        this.gameover = undefined;
    }

    this.div.pause_button.disabled=false;

    for (var x=0; x<this.blocks.length; x++)
        this.blocks[x] = new Array(10);
    this.level.set(0);
    this.lines.set(0);

    this.bottom=0;
    this.pick_next();
    this.step();

    this.input_focus();
  }
}

var enable_canvas = plat.has_canvas && 1;

var the_game = new Sirtet(enable_canvas ? doc.id("canvas_board") : doc.id("board"),
                          enable_canvas ? doc.id("canvas_next")  : doc.id("next"),
                          doc.id("score"),
                          doc.id("level"),
                          doc.id("lines"),
                          doc.id("global_high_score"),
                          doc.id("scoretab"),
                          doc.id("start"),
                          doc.id("pause"),
                          doc.id("next_toggle"),
                          doc.id("slow_drop"));

if (enable_canvas) {
    doc.id("canvas_board_wrapper").style.display = "block";
    doc.id("canvas_next").style.display = "block";

    window.onresize = function() {
        var wrapper = doc.id("canvas_board_wrapper");
        the_game.resize(Math.min(Math.floor(wrapper.clientWidth / 10),
                                 Math.floor(wrapper.clientHeight / 22)));
    }
} else {
    doc.id("board").style.display = "block";
    doc.id("next").style.display = "block";
    window.onresize = function() {
        the_game.resize(Math.floor(plat.windowHeight()*.80 / 22))
    };
}

on_load(function () {
    window.onresize();
    the_game.new_game(URL.param.game);

    doc.id("keybinding-toggle").onclick = (event) => {
        doc.id('keys').classList.toggle("hidden");
        return false;
    }
});


require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
// Copyright 2005-2006 Jim Radford <radford@blackbean.org>
// Copyright 2005-2006 David Caldwell <david@porkrind.org>

var dom = require('./dom'), px=dom.px, doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, URL=dom.URL, on_load=dom.on_load, animate_next_frame=dom.animate_next_frame;
var score = require('./score'), Stat=score.Stat;
var lib = require('./lib'), inherit=lib.inherit, shuffle_perfect=lib.shuffle_perfect;
var plat = require('./platform');
var score_game = require('./score_game');
var KeyboardFocusAutoPause = require('./keyfocus');
var DrawThreeDSquare = require('./3dsquare');

function img(source, r, c, width, height) {
    var image=document.createElement("img");
    image.src=source;
    image.style.width=px(width);
    image.style.height=px(height);
    image.width=width;
    image.height=height;
    image.style.position="absolute";
    image.style.left=px(c);
    image.style.top=px(r);
    image.style.border="0";
    return image;
}

function img_move(img, r, c) {
    img.style.left = px(c);
    img.style.top  = px(r);
}

function chamfer_row(grid, r, edges) {
     if (r >= 0 && r < grid.length)
         for (var c=0; c<grid[r].length; c++)
             grid[r][c] && grid[r][c].chamfer(grid, r, c, edges);
     return true;
}
function chamfer(grid) {
     for (var r=0; r<grid.length; r++)
        chamfer_row(grid, r);
}

var north = 1<<0, east = 1<<1, south = 1<<2, west = 1<<3;

class square {
    constructor(color, r, c, edge, ghost) {
        this.color = color;
        this.r = r;
        this.c = c;
        this.edge = edge;
    }
    // Implement these in the subclass
    copy() {}
    move(r, c) {}
    show(div) {}
    hide() {}
    draw() {}

    same(grid, r, c) {
            return r >= 0 && r < grid.length && grid[r] &&
                c >= 0 && c < grid[r].length && grid[r][c] &&
                this.color == grid[r][c].color;
    }

    toString() {
            return "" + this.color + ":" + this.edge + "(" + this.c + "," + this.r + ")";
    }

    chamfer(grid, r, c, edges) {
            var edge =
                (this.same(grid,r-1,c) ? north : 0) |
                (this.same(grid,r+1,c) ? south : 0) |
                (this.same(grid,r,c-1) ? west :  0) |
                (this.same(grid,r,c+1) ? east :  0);
            if (edges == undefined) edges = 0xf;
            if ((edge & edges) != (this.edge & edges)) {
                this.edge = (this.edge & ~edges) | (edge & edges);
                this.draw();
            }
    }
}

class img_square extends square {
    color_map = ["red", "purple", "aqua", "yellow", "orange", "blue", "green", "grey", "maroon" ];

    edge_map = (
            function () {
                var map = [];
                for (var i=0; i<16; i++)
                    map[i] = (i&north?"n":"")+(i&south?"s":"")+(i&east?"e":"")+(i&west?"w":"");
                return map;
            }
    )();

    source() {
            return "blocks/"+this.color_map[this.color]+"-"+blocksize+"-"+this.edge_map[this.edge] + ".png";
    }

    copy() {
            return new img_square(this.color, this.r, this.c, this.edge);
    }

    move(r, c) {
            this.r = r;
            this.c = c;
            if (this.img)
                img_move(this.img, r*blocksize, c*blocksize);
    }

    show(div) {
            if (this.img == undefined)
                this.img = img(this.source(), this.r*blocksize, this.c*blocksize, blocksize, blocksize);
            div.appendChild(this.img);
    }

    hide() { this.img.parentNode.removeChild(this.img) }
    draw() { if (this.img) this.img.src = this.source(); }
}

class canvas_square extends square {
    constructor(color, r, c, edge, ghost) {
        super(color, r, c, edge);
        this.set_origin(0,0);
        this.ghost = ghost;
    }

    colors = [{ name: "red",        r:0xd0, g:0x00, b:0x00 },
              { name: "purple",     r:0xd0, g:0x00, b:0xd0 },
              { name: "aqua",       r:0x10, g:0x50, b:0xd0 },
              { name: "yellow",     r:0xd0, g:0xd0, b:0x00 },
              { name: "orange",     r:0xd0, g:0x70, b:0x00 },
              { name: "blue",       r:0x00, g:0x00, b:0xd0 },
              { name: "green",      r:0x00, g:0xd0, b:0x00 },
              { name: "grey",       r:0x66, g:0x66, b:0x66 },
              { name: "maroon",     r:0xa0, g:0x20, b:0x10 }];

    outline_color_func(kind, main) {
            if (kind == "Main") return { r:0, g:0, b:0, a:0 }
            return main;
    }

    draw() {
            if (!this.context) return;
            this.erase(); // When re-chamfering lines we need to erase. In other cases someone already called hide() and this is redundant.
            DrawThreeDSquare(this.context, (this.oc + this.c)*blocksize,(this.or + this.r)*blocksize,blocksize, this.ghost ? Math.floor(blocksize/8) : Math.floor(blocksize/5),2,this.colors[this.color],
                             this.edge & north,this.edge & south,this.edge & east,this.edge & west, this.ghost ? this.outline_color_func : undefined)
    }

    erase() {
            if (this.context)
                this.context.clearRect((this.oc + this.c) * blocksize, (this.or + this.r) * blocksize, blocksize, blocksize);
    }

    set_origin(or, oc) {
            this.or = or;
            this.oc = oc;
    }

    copy() {
            return new canvas_square(this.color, this.r, this.c, this.edge, this.ghost);
    }

    move(r, c) {
            if (this.visible) this.erase();
            this.r = r;
            this.c = c;
            if (this.visible) this.draw();
    }

    show(canvas) {
            this.visible = true;
            this.canvas = canvas;
            this.context = canvas.getContext('2d');
            this.draw();
    }

    hide(erase) {
            this.visible = false;
            if (erase !== false) this.erase();
    }
}

class piece {
    constructor(color, coords, square, ghost) {
        this.color = color;
        this.squares = [];
        for (var i in coords)
            this.squares.push(new square(color, coords[i][0], coords[i][1], 0, ghost));

        var grid = [[],[],[],[]]; // temporary grid for chamfering
        for (var s in this.squares)
            grid[this.squares[s].r][this.squares[s].c] = this.squares[s];
        chamfer(grid);
    }
    move(r, c) {}
    show(div) {}
    hide() {}
}

class img_piece extends piece {
    constructor(color, coords, ghost) {
        super(color, coords, img_square, ghost);

        this.div = doc.el("div", {style: {position:"absolute", opacity: ghost == true ? .4 : 1, zIndex: ghost == true ? 1 : 2}});
        for (var i in this.squares)
            this.squares[i].show(this.div);
    }
    move(r, c) {
            this.div.style.top = px(r*blocksize);
            this.div.style.left = px(c*blocksize);
            return this;
    }
    show(div) { div.appendChild(this.div); return this.div; }
    hide() { if (this.div.parentNode) this.div.parentNode.removeChild(this.div);  return this.div; }
}

class canvas_piece extends piece {
    constructor(color, coords, ghost) {
        super(color, coords, canvas_square, ghost);
    }
    draw() {
            for (var s of this.squares)
                s.draw(this.r, this.c);
    }
    erase() {
            for (var s of this.squares)
                s.erase();
    }
    move(r, c) {
            if (this.visible) this.erase();
            for (var s of this.squares)
                s.set_origin(r,c);
            if (this.visible) this.draw();
            return this;
    }
    show(canvas) {
            if (this.visible) return;
            this.visible = true;
            for (var s of this.squares)
                s.show(canvas);
    }
    hide(erase) {
            if (!this.visible) return;
            this.visible = false;
            for (var s of this.squares)
                s.hide(erase);
    }
}

var blocksize=20;
class Sirtet extends KeyboardFocusAutoPause.mixin(score_game) {
  constructor(board_div, next_div, score_div, level_div, lines_div, highscore_div, highscoretabs_div, start_div, pause_div, next_toggle_div, slow_drop_div) {
    super();
    this.init("sirtet", score_div, highscore_div, highscoretabs_div);
    this.div = {};
    this.div.board = board_div;
    this.div.next = next_div;
    this.div.start_button = start_div;
    this.div.pause_button = pause_div;
    this.div.next_checkbox = next_toggle_div;
    this.div.slow_drop_checkbox = slow_drop_div;
    this.div.start_button.onclick = function() { this.new_game(); }.bind(this);

    this.init_keyboard_focus_auto_pause(this.div.board, this.div.pause_button);

    this.div.next_checkbox.onclick = function() { this.next_toggle(this.div.next_checkbox.checked); }.bind(this);

    this.level = new Stat(level_div, "level", this.stats);
    this.lines = new Stat(lines_div, "lines", this.stats);

    this.blocks = new Array(22);

    this.next_toggle(1);

    this.sets_in_bag = 1;

    this.gameover = undefined;

    this.bottom_tolerance = 1; // extra moves on the ground
    this.animating = {};

    this.register_key_events(function(event) {
        //print("x: "+ event.target.x + ", y: "+ event.target.y + "\n");
        switch(event.key) {
            case "+":      this.resize(++blocksize); return false;
            case "-":      this.resize(--blocksize); return false;
            case "p":
            case "escape": this.key_pause();   return false;
            case "n":      this.next_toggle(); return false;
        }
        if (this.paused || this.gameover || this.animating.line_removal) return true; // No input allowed in these states!
        switch(event.key) {
            case "k":
            case "up":     this.rotate();      return false;
            case "space":  this.drop();        return false;
            case "down":   if (this.slow_drop()) this.down(); else this.drop(); return false;
            case "j":
            case "left":   this.left();        return false;
            case "l":
            case "right":  this.right();       return false;
            case "i":      if (this.level.get() < 9) { this.level.inc(1); this.stats.inc("levels_incremented") };
        }
    }, "keydown");

    this.resize = function(size) {
        if (board_div.tagName.toLowerCase() == 'canvas') {
            blocksize = size;
            this.div.board.height = 22*size;
            this.div.board.width = 10*size;
            this.div.next.height = 2*size;
            this.div.next.width = 4*size;
            this.div.board.getContext('2d').clearRect(0, 0, this.div.board.width, this.div.board.height);
            this.div.next.getContext('2d').clearRect(0, 0, this.div.next.width, this.div.next.height);

        } else {
            blocksize = size = size > 32 ? 32 : size < 10 ? 10 : size;
            this.div.board.style.height = px(22*size);
            this.div.board.style.width = px(10*size);
            this.div.next.parentNode.style.height =
            this.div.next.style.height = px(2*size);
            this.div.next.style.width = px(4*size);
        }
        if (this.gameover) {
            this.gameover.style.width  = px(10*size);
            this.gameover.style.height = px( 5*size);
            this.gameover.style.top    = px( 9*size);
        }
        if (this.paused) {
            this.paused_div.style.width  = px(10*size);
            this.paused_div.style.height = px( 5*size);
            this.paused_div.style.top    = px( 9*size);
        }
        this.pieces_reset();
        this.pieces_generate();
        this.update();
        if (this.piece != undefined) {
            this.pieces[this.piece][this.orient].hide();
            this.pieces[this.piece][this.orient].move(this.r, this.c);
            this.pieces[this.piece][this.orient].show(this.div.board);
        }
        if (this.next != undefined) {
            this.pieces_next[this.next].hide();
            this.pieces_next[this.next].show(this.div.next);
        }
    };

    if (board_div.tagName.toLowerCase() == 'canvas') {
        this.piece_factory = canvas_piece;
        this.square_factory = canvas_square;
    } else {
        this.piece_factory = img_piece;
        this.square_factory = img_square;
    }

  }

  pieces_generate() {
    var d = [
        { sym:2, rc:[[1, 0], [1, 1], [1, 2], [1, 3]], o:[1, 2] }, // J
        { sym:4, rc:[[1, 0], [1, 1], [1, 2], [0, 2]], o:[1, 1] }, // I
        { sym:2, rc:[[1, 1], [1, 2], [0, 2], [0, 3]], o:[1, 2] }, // S
        { sym:4, rc:[[0, 1], [1, 1], [1, 2], [1, 3]], o:[1, 2] }, // L
        { sym:2, rc:[[0, 0], [0, 1], [1, 1], [1, 2]], o:[1, 1] }, // Z
        { sym:1, rc:[[0, 1], [0, 2], [1, 1], [1, 2]], o:[1, 1] }, // O
        { sym:4, rc:[[1, 0], [1, 1], [0, 1], [1, 2]], o:[1, 1] }  // T
    ];
    this.pieces = [];
    this.ghosts = [];
    this.pieces_next = [];
    for (var color=0; color<d.length; color++) {
        this.pieces[color] = [];
        this.ghosts[color] = [];
        this.pieces_next[color] = new this.piece_factory(color, d[color].rc);
        for (var o=0; o<d[color].sym; o++) {
            this.pieces[color].push(new this.piece_factory(color, d[color].rc));
            this.ghosts[color].push(new this.piece_factory(color, d[color].rc, true));
            for (var s in d[color].rc) { // rotate 90
                var  r = d[color].rc[s][0], c = d[color].rc[s][1];
                var or = d[color].o[0],    oc = d[color].o[1];
                d[color].rc[s] = [or-(c-oc), oc+(r-or)];
            }
        }
    }
    this.first = [0, 1, 3, 6]; // J, I, L, T
  }
  pieces_reset() {
    if (this.pieces)
        for (var color=0; color<this.pieces.length; color++) {
            this.pieces_next[color].hide();
            for (var o=0; o<this.pieces[color].length; o++)
                this.pieces[color][o].hide();
            for (var o=0; o<this.ghosts[color].length; o++)
                this.ghosts[color][o].hide();
        }
  }

  remove_all() {
    for (var r=0; r<this.blocks.length; r++)
        if (this.blocks[r])
            for (var c=0; c<this.blocks[r].length; c++)
                this.remove(r,c);
  }

  empty(r, c) {
    return r >= 0 && r < this.blocks.length &&
           c >= 0 && c < this.blocks[r].length &&
           this.blocks[r][c] == undefined;
  }

  fits(piece, r, c) {
    for (var s=0; s<piece.squares.length; s++) {
        var sq = piece.squares[s];
        if (!this.empty(r + sq.r, c + sq.c))
            return;
    }
    return piece;
  }

  down  () { return this.move(1,0,0) }
  left  () { return this.move(0,-1,0) }
  right () { return this.move(0,1,0) }
  rotate() { return this.move(0,0,1) }

  move(dr, dc, i) {
    var o = (this.orient+i) % this.pieces[this.piece].length
    var piece = this.pieces[this.piece][o];
    if (!this.fits(piece, this.r + dr, this.c + dc)) {
        if      (i && this.fits(piece, this.r + dr, this.c + dc + 1)) dc++;
        else if (i && this.fits(piece, this.r + dr, this.c + dc - 1)) dc--;
        else return;
    }
    this.move_ghost(dr, dc, o);
    piece.move(this.r += dr, this.c += dc);
    if (this.orient != o) {
        this.pieces[this.piece][this.orient].hide();
        this.pieces[this.piece][o].show(this.div.board);
        this.orient = o;
    }
    if (this.bottom)
        this.stats.inc(i ? "bottom_rotates" : "bottom_slides");
    return true;
  }

  move_ghost(dr, dc, o) {
    var ghost = this.ghosts[this.piece][o];
    for (var r = this.r + dr; this.fits(ghost, r+1, this.c + dc); r++)
        ;
    ghost.move(r, this.c+dc);
    if (this.orient != o) {
        this.ghosts[this.piece][this.orient].hide();
        this.ghosts[this.piece][o].show(this.div.board);
    }
  }

  drop() {
    cancel_timeout(this.timeout);
    var piece = this.pieces[this.piece][this.orient];
    for (var i=0; this.fits(piece, this.r+i+1, this.c); i++)
        ;
    this.score.inc(i*(this.level.get()+1));
    this.move(i,0,0);
    this.bottom=this.bottom_tolerance;
    this.step(true);
    this.stats.inc("drops");
    this.stats.inc("drop_height_total", i);
  }

  update() {
    for (var r=0; r<this.blocks.length; r++)
       if (this.blocks[r])
           for (var c=0; c<this.blocks[r].length; c++)
                if (this.blocks[r][c]) {
                    this.blocks[r][c].hide();
                    this.blocks[r][c].img = undefined;
                    this.blocks[r][c].show(this.div.board);
                }
  }
  move_to(square, r, c) {
    this.blocks[r][c] = square;
    square && square.move(r,c);
    square && square.show(this.div.board);
  }
  remove(r) {
    for (var c=0; c<this.blocks[r].length; c++)
        this.blocks[r][c] && this.blocks[r][c].hide();
    var removed = this.blocks[r]; this.blocks[r] = Array(10);
    return removed;
  }
  insert(r, row) {
    for (var c=0; c<row.length; c++)
        this.move_to(row[c], r, c);
  }
  merge(complete) {
    this.ghosts[this.piece][this.orient].hide(false);
    var n, piece = this.pieces[this.piece][this.orient];
    for (var s=0; s<piece.squares.length; s++) {
        var sq = piece.squares[s].copy();
        this.move_to(sq, this.r+sq.r, this.c+sq.c);
    }
    // Count empty holes the player left. Note that it doesn't take into account the lines that are
    // subsequently removed which may open the "holes" up to the sky (and therefore not really count as
    // holes). Perhaps a better way would be to compare the state of the board before merge/line removal and
    // after, counting holes in each and noting the increase (decreases wouldn't matter).
    for (var s=0; s<piece.squares.length; s++)
        for (var r=this.r+piece.squares[s].r+1; r<this.blocks.length && !this.blocks[r][this.c+piece.squares[s].c]; r++)
            this.stats.inc("holes_created");
    piece.hide(false);

    var full_rows = [];
    for (let r=this.blocks.length-1; r>=0; r--) {
        for (var c=0; c<this.blocks[r].length; c++)
            if (this.empty(r,c))
                break;
        if (c == this.blocks[r].length) {
            full_rows[r] = true;
            this.remove(r);
        }
    }

    if (full_rows.length == 0)
        return complete();

    for (var r in full_rows) {
        if (!full_rows[r-0-1]) chamfer_row(this.blocks, r-0-1, south);
        if (!full_rows[r-0+1]) chamfer_row(this.blocks, r-0+1, north);
    }

    const total_time = 250, blinks = 3;
    this.animate(function*() {
                     this.animating.line_removal = true;
                     for (var count=0; count<blinks*2; count++) {
                         for (var r in full_rows) {
                             this.remove(r);
                             for (var c=0; c<this.blocks[r].length; c++)
                                 this.move_to(new this.square_factory(7, 0, 0, 0, !(count & 2)), r, c);
                         }
                         yield total_time / (blinks*2);
                     }
                     delete this.animating.line_removal;

                     var full = 0;
                     for (var r=this.blocks.length-1; r>=0; r--) {
                         if (full_rows[r]) {
                             full++; this.remove(r);
                         } else {
                             full && this.insert(r+full, this.remove(r));
                         }
                     }
                     this.score.inc( (1<<full) * (this.level.get() + (this.show_next || this.seen_next ? 1 : 5)) );
                     this.seen_next = false;
                     this.faster(this.lines.inc(full));
                     complete();
                     this.step(false);
                 }.bind(this));
  }

  animate(animate_generator) {
    var start = Date.now();
    var animate = animate_generator();
    var frame = (dt, t) => {
        var state = animate.next();
        if (!state.done)
            timeout(state.value, frame);
    };
    frame();
  }

  faster(lines) {
    var level = this.level.get();
    if (level <  6 && lines > (level+1)*10) level = this.level.inc(1);
    if (level == 6 && lines >  74) this.level.set(7);
    if (level == 7 && lines >  89) this.level.set(8);
    if (level == 8 && lines > 104) this.level.set(9);
  }

  pick_next() {
    this.piece = this.next;
    if (this.piece == undefined) // Don't be annoying on the first piece (it doesn't really add challenge, it just makes the 2nd piece suck).
        this.piece = this.first[Math.floor(Math.random()*this.first.length)];
    this.orient = 0;
    this.r = 0;
    this.c = 3;

    if (this.next != undefined)
        this.pieces_next[this.next].hide();
    if ((this.bag_pos = (this.bag_pos + 1) % this.bag.length) == 0)
        shuffle_perfect(this.bag);
    this.next = this.bag[this.bag_pos];
    this.pieces_next[this.next].show(this.div.next);

    var piece = this.pieces[this.piece][this.orient];
    if (this.fits(piece, this.r, this.c)) {
        this.move_ghost(0,0,this.orient);
        this.ghosts[this.piece][this.orient].show(this.div.board);
        piece.move(this.r, this.c);
        piece.show(this.div.board);
        this.stats.inc("pieces");
    } else {
        this.piece = this.orient = undefined;
        cancel_timeout(this.timeout);
        this.gameover = img("hopeless/gameover.png", blocksize*9,0,10*blocksize, 5*blocksize);
        this.gameover.style.zIndex=2;
        this.div.board.appendChild(this.gameover);
        this.div.pause_button.disabled=true;
        this.end_game();
    }
  }

  delay = [70,67,55,40,34,25,20,18,14,9,5];
  step(move) {
    if (move && !this.down() && this.bottom++ == this.bottom_tolerance) {
        this.bottom=0;
        this.merge(() => this.pick_next());
    }
    if (!this.gameover && !this.animating.line_removal)
        this.timeout = timeout((this.delay[this.level.get()]+(this.r<3?10:0))*10, function() { this.step(true); }.bind(this));
  }

  pausable() {
    return !this.gameover;
  }
  on_pause() {
    cancel_timeout(this.timeout);
    this.paused_div = img("hopeless/paused.png", blocksize*9,0,10*blocksize, 5*blocksize);
    this.paused_div.style.zIndex=2;
    this.div.board.appendChild(this.paused_div);
  }
  on_unpause() {
    this.paused_div.parentNode.removeChild(this.paused_div);
    this.paused_div = undefined;
    this.step();
  }

  slow_drop() {
    return this.div.slow_drop_checkbox.checked;
  }

  next_toggle(value) {
    this.show_next = value == undefined ? !this.show_next : value;
    this.seen_next |= this.show_next;
    this.div.next.style.display = this.show_next ? "block" : "none";
    if (this.div.next_checkbox.checked != value) this.div.next_checkbox.checked = value;
  }

//var stats_ = new stats(this.name = name);
  new_game(seed) {
    score_game.prototype.new_game.call(this,seed);

    //for (var c=0; c<this.pieces.length; c++)
    //    for (var o=0; o<this.pieces[c].length; o++) {
    //        this.pieces[c][o].move(c*4,0*4);
    //        this.pieces[c][o].show(this.div.board);
    //    }
    //return;

    this.next = undefined;
    this.bag = [];
    for (var c=0; c<this.pieces.length * this.sets_in_bag; c++)
        this.bag[c] = c % this.pieces.length;
    this.bag_pos = -1;

    if (this.paused) this.pause(false); // Will start timout for previous game!

    if (this.timeout) cancel_timeout(this.timeout);
    this.remove_all();
    this.pieces_reset();

    if (this.gameover != undefined) {
        this.gameover.parentNode.removeChild(this.gameover);
        this.gameover = undefined;
    }

    this.div.pause_button.disabled=false;

    for (var x=0; x<this.blocks.length; x++)
        this.blocks[x] = new Array(10);
    this.level.set(0);
    this.lines.set(0);

    this.bottom=0;
    this.pick_next();
    this.step();

    this.input_focus();
  }
}

var enable_canvas = plat.has_canvas && 1;

var the_game = new Sirtet(enable_canvas ? doc.id("canvas_board") : doc.id("board"),
                          enable_canvas ? doc.id("canvas_next")  : doc.id("next"),
                          doc.id("score"),
                          doc.id("level"),
                          doc.id("lines"),
                          doc.id("global_high_score"),
                          doc.id("scoretab"),
                          doc.id("start"),
                          doc.id("pause"),
                          doc.id("next_toggle"),
                          doc.id("slow_drop"));

if (enable_canvas) {
    doc.id("canvas_board_wrapper").style.display = "block";
    doc.id("canvas_next").style.display = "block";

    window.onresize = function() {
        var wrapper = doc.id("canvas_board_wrapper");
        the_game.resize(Math.min(Math.floor(wrapper.clientWidth / 10),
                                 Math.floor(wrapper.clientHeight / 22)));
    }
} else {
    doc.id("board").style.display = "block";
    doc.id("next").style.display = "block";
    window.onresize = function() {
        the_game.resize(Math.floor(plat.windowHeight()*.80 / 22))
    };
}

on_load(function () {
    window.onresize();
    the_game.new_game(URL.param.game);

    doc.id("keybinding-toggle").onclick = (event) => {
        doc.id('keys').classList.toggle("hidden");
        return false;
    }
});


require('./gotd').start = function(game_of_the_day) { the_game.new_game(game_of_the_day) };
